module.exports = __webpack_public_path__ + "img-dashboard/register/image-circle-blue.e77d73af.svg";